import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { UserBasicInfo } from "../../Modules/UserRole/userBasicInfo";



interface contextValue {
    IsAdminRh: boolean;
    isAssistantRh: boolean;
    isModerateur: boolean;
    isDevRh: boolean;
    isManager: boolean;
    seConnecter: (userBasic: UserBasicInfo) => void;
    vider: () => void;
    basicUserInfo?: UserBasicInfo
    isLoading: boolean
}

export const RoleContext = createContext<contextValue | undefined>(undefined)

interface providerProps {
    children: ReactNode;
}

const ISMOD = "isModerateur";
const ISAMDIN = "IsAdminRh"
const ISARH = "isAssistantRh"
const ISDEVRH = "isDevRh"
const ISMANAGER = "isManager"
const USERINFO = "userInfo";

export const RoleProvider: React.FC<providerProps> = ({ children }) => {


    const [basicUserInfo, setBasicUserInfo] = useState<UserBasicInfo | undefined>
        (
            localStorage.getItem(USERINFO)
                ? JSON.parse(localStorage.getItem(USERINFO) as string)
                : undefined
        )


    const [IsAdminRh, setIsAdminRh] = useState(false)
    const [isAssistantRh, setIsAssistantRh] = useState(false)
    const [isModerateur, setIsModerateur] = useState(false)
    const [isDevRh, setIsDevRh] = useState(false)
    const [isManager, setIsManager] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    const seConnecter = (result: UserBasicInfo) => {    
        setBasicUserInfo(result)
        if (result.nomRole === "Admin") {
            setIsAdminRh(true);
            localStorage.setItem(ISAMDIN, JSON.stringify("yes"));
        }
        if (result.nomRole === "AssistantRh") {
            setIsAssistantRh(true);
            localStorage.setItem(ISARH, JSON.stringify("yes"));
        }
        if (result.nomRole === "Moderateur") {
            setIsModerateur(true);
            localStorage.setItem(ISMOD, JSON.stringify("yes"));
        }
        if (result.nomRole === "DevRh") {
            setIsDevRh(true)
            localStorage.setItem(ISDEVRH, JSON.stringify("yes"));
        }
        if (result.nomRole === "Manager") {
            setIsManager(true)
            localStorage.setItem(ISMANAGER, JSON.stringify("yes"))
        }

        localStorage.setItem(USERINFO, JSON.stringify(result))
    }




    const vider = () => {
        localStorage.removeItem(ISAMDIN);
        localStorage.removeItem(ISARH);
        localStorage.removeItem(ISMOD);
        localStorage.removeItem(ISDEVRH)
        localStorage.removeItem(USERINFO)
        localStorage.removeItem(ISMANAGER)
        setIsAdminRh(false)
        setIsAssistantRh(false)
        setIsModerateur(false)
        setIsDevRh(false)
        setIsManager(false)
        setBasicUserInfo(undefined)
    }

    const check = () => {
        const isAdmin = localStorage.getItem(ISAMDIN)
            ? JSON.parse(localStorage.getItem(ISAMDIN) as string)
            : null

        const isARh = localStorage.getItem(ISARH)
            ? JSON.parse(localStorage.getItem(ISARH) as string)
            : null
        const isMod = localStorage.getItem(ISMOD)
            ? JSON.parse(localStorage.getItem(ISMOD) as string)
            : null
        const isDevRh = localStorage.getItem(ISDEVRH)
            ? JSON.parse(localStorage.getItem(ISDEVRH) as string)
            : null
        const isManager = localStorage.getItem(ISMANAGER)
            ? JSON.parse(localStorage.getItem(ISMANAGER) as string)
            : null

        isAdmin === "yes" ? setIsAdminRh(true) : setIsAdminRh(false)
        isARh === "yes" ? setIsAssistantRh(true) : setIsAssistantRh(false)
        isMod === "yes" ? setIsModerateur(true) : setIsModerateur(false)
        isDevRh === "yes" ? setIsDevRh(true) : setIsDevRh(false)
        isManager === "yes" ? setIsManager(true) : setIsManager(false)
    }

    const location = useLocation()
    useEffect(() => {
        setIsLoading(true)
        check()
        setIsLoading(false)
    }, [location])

    return (
        <RoleContext.Provider value={{ IsAdminRh, isAssistantRh, isManager,  vider, isModerateur, isDevRh, seConnecter, basicUserInfo, isLoading }}>
            {children}
        </RoleContext.Provider>
    )
}

export const IsAdminRh = () => {
    const context = useContext(RoleContext)
    if (context === undefined) {
        throw new Error('IsAdminRh must be used within a RoleProvider')
    }
    return context.IsAdminRh
}

export const IsAssistantRh = () => {
    const context = useContext(RoleContext)
    if (context === undefined) {
        throw new Error('IsAdminRh must be used within a RoleProvider')
    }
    return context.isAssistantRh
}

export const IsManager = () => {
    const context = useContext(RoleContext)
    if (context === undefined) {
        throw new Error('isManger must be used within a RoleProvider')
    }
    return context.isManager
}

export const GetUserInfo = () => {
    const context = UseRoleContext()
    if (context === undefined) {
        throw new Error('GetUserInfo must be used within a RoleProvider')
    }
    return context.basicUserInfo
}

export const UseRoleContext = () => {
    const context = useContext(RoleContext)
    if (context === undefined) {
        throw new Error('IsAdminRh must be used within a RoleProvider')
    }
    return context
}